<div
  class="button-bar"
  [class.allow-vertical-top-bar]="allowVertical"
  [class.small-icons]="smallIcons"
  [style.transform]=scaleButtons
>
  <ion-buttons slot="start button-bar-buttons" class="button-bar-buttons">
    <div
      class="button-bar-button-wrapper"
      [class.button-bar-spacer]="btn.spacer"
      *ngFor="let btn of buttons"
    >
      <ion-button
        class="button-bar-button"
        [class.show-text]="btn.showText"
        [tooltip]="btn.tooltip | translate"
        [display]="showTooltips"
        placement="bottom"
        fill="solid"
        color="primary"
        (click)="btn.function($event)"
        *ngIf="!btn.custom && !btn.sweepstakeButton && !btn.spacer"
        [disabled]="btn.disabled || this[btn.disabledProp]"
        size="small"
      >
        <ion-icon
          [class.has-badge]="!!btn.badge && !this[btn.matBadgeHidden]"
          class="button-bar-icon {{btn.name}}"
          name="{{btn.icon}}"
          slot="icon-only"
          size="small"
        />
        <div class="button-text">{{ btn.title | translate }}</div>
      </ion-button>
      <ion-badge
        class="button-bar-badge {{btn.name}}"
        *ngIf="btn.badge && !this[btn.matBadgeHidden]"
        color="secondary"
      >
        {{ this[btn.badge] }}
      </ion-badge>
      <lib-app-puzzle-button-custom *ngIf="btn.custom" [customID]="btn.customID" />
      <lib-app-puzzle-sweepstake-button *ngIf="btn.sweepstakeButton" />
    </div>

  </ion-buttons>

</div>

